import React, { useEffect, useState } from 'react';
import {
    Grid,
    TextField,
    Button,
    Dialog,
    DialogContent,
    Typography,

} from '@mui/material';
import { Field, useField, useFormik } from 'formik';
import { toast } from 'react-toastify';
import AppDialogTitle from '../../../ui/appDialogTitle';
import { isLocalDev } from '../../../../utils/environment';
import { ValidDataService } from '../../../../service/validDataService';
import SupplierListDialog from '../../ValidData/validSupplier/supplierListDialog';
import SectionTitle from '../../../ui/sectionTitle';
import SimpleDatePicker from '../../../ui/simpleDatePicker';
import BrandListDialog from '../../ValidData/validSupplier/brandListDialog';
import ValidFrameBasicInfo from '../frames/validFrameBasicInfoForm';
import ValidFrameCostAndPricingForm from '../frames/validFrameCostAndPricingForm';
import { ACCEPTED_IMAGE_FILE_FORMAT, formatFileSize } from '../../../../utils';
import AttachmentUploader from '../../../common/attachmentUploader';
import lensValidationSchema, { initialValuesLensForm } from './lensValidationSchema';
import ValidLensPropertiesForm from './validLensPropertiesForm';
import labels from './labels.json';
import { AttachmentService } from '../../../../service/attachmentService';
import validLookup from '../../../../utils/validLookup';

const MAX_FILE_SIZE = 10 * 1024 * 1024
const MAX_NO_OF_FILES = 10

export default function ValidLensEditForm({ open, onClose, onRecordUpdated, onRecordCopied, recordToEdit, isCopy = false }) {
    const [supplierDialogOpen, setSupplierDialogOpen] = useState(false);
    const [brandDialogOpen, setBrandDialogOpen] = useState(false);
    const [attachments, setAttachments] = useState([])
    
    const formik = useFormik({
        initialValues: {
            ...initialValuesLensForm,
            ...recordToEdit,
            sku: recordToEdit.sku || '',
            supplierName: recordToEdit.supplier ? recordToEdit.supplier.supplierName || '' : '',
            brand: recordToEdit.brand ? recordToEdit.brand.name || '' : '',
            supplierCost: recordToEdit.supplierCost ? recordToEdit.supplierCost : '',
            landingCost: recordToEdit.landingCost ? recordToEdit.landingCost : '',
            listPrice: recordToEdit.listPrice ? recordToEdit.listPrice : '',
            validationSchema: lensValidationSchema,
            properties: {
                ...recordToEdit.lensproperties,
                lensType: recordToEdit.lensproperties.lensType ? recordToEdit.lensproperties.lensType : '',
                material: recordToEdit.lensproperties.material ? recordToEdit.lensproperties.material : '',
                lensOu: recordToEdit.lensproperties.lensOu ? recordToEdit.lensproperties.lensOu : '',
                sphere: recordToEdit.lensproperties.sphere ? recordToEdit.lensproperties.sphere : '',
                cyl: recordToEdit.lensproperties.cyl ? recordToEdit.lensproperties.cyl : '',
                axis: recordToEdit.lensproperties.axis ? recordToEdit.lensproperties.axis : '',
                addPower: recordToEdit.lensproperties.addPower ? recordToEdit.lensproperties.addPower : '',
                bc: recordToEdit.lensproperties.bc ? recordToEdit.lensproperties.bc : '',
                size: recordToEdit.lensproperties.size ? recordToEdit.lensproperties.size : '',
                ed: recordToEdit.lensproperties.ed ? recordToEdit.lensproperties.ed : '',
                segHt: recordToEdit.lensproperties.segHt ? recordToEdit.lensproperties.segHt : '',
            },
            profit: recordToEdit.profit ? recordToEdit.profit : '',
            profitPercentage: recordToEdit.profitPercentage ? recordToEdit.profitPercentage : '',
            lastOrdered: recordToEdit.lastOrdered ? recordToEdit.lastOrdered : '',
            lastReceived: recordToEdit.lastReceived ? recordToEdit.lastReceived : '',
            lastSold: recordToEdit.lastSold ? recordToEdit.lastSold : '',
            totalSold: recordToEdit.totalSold ? recordToEdit.totalSold : '',
            returned: recordToEdit.returned ? recordToEdit.returned : '',
            quantityOnOrder: recordToEdit.quantityOnOrder ? recordToEdit.quantityOnOrder : '',
            quantityOnHand: recordToEdit.quantityOnHand ? recordToEdit.quantityOnHand : '',
            notes: recordToEdit.notes ? recordToEdit.notes : '',
        },
        onSubmit: (values) => {
            onSubmit(values);
        },
    });
    const { values, setFieldValue, handleChange, handleSubmit, touched } = formik;

    useEffect(() => {

        (async () => {
            if (!recordToEdit || !recordToEdit.id) return;
            const attachments = await AttachmentService.getAttachment('lens', recordToEdit.id)
            const { code, message, data } = attachments
            if (code === 0) {
                setAttachments(data)
            }
        })()
    }, [recordToEdit])

    const onSubmit = async (values) => {
        formik.setSubmitting(true);
        const { properties, lensproperties, ...rest } = values;
        try {
            const formattedValues = {
                ...rest,
                supplierCost: values.supplierCost === '' ? null : parseFloat(values.supplierCost),
                landingCost: values.landingCost === '' ? null : parseFloat(values.landingCost),
                listPrice: values.listPrice === '' ? null : parseFloat(values.listPrice),
                photos: values.photos === '' ? null : values.photos,
                type: 'lens',
                locationId: values.location.id,
                profit: values.profit === '' ? null : parseFloat(values.profit),
                profitPercentage: values.profitPercentage === '' ? null : parseFloat(values.profitPercentage),
                lastOrdered: values.lastOrdered === '' ? null : values.lastOrdered,
                lastReceived: values.lastReceived === '' ? null : values.lastReceived,
                lastSold: values.lastSold === '' ? null : values.lastSold,
                totalSold: values.totalSold === '' ? null : parseInt(values.totalSold, 10),
                returned: values.returned === '' ? null : parseInt(values.returned, 10),
                quantityOnOrder: values.quantityOnOrder === '' ? null : parseInt(values.quantityOnOrder, 10),
                quantityOnHand: values.quantityOnHand === '' ? null : parseInt(values.quantityOnHand, 10),
                properties: {
                    ...properties,
                    lensType: values.properties.lensType === '' ? null : values.properties.lensType,
                    material: values.properties.material === '' ? null : values.properties.material,
                    lensOu: values.properties.lensOu === '' ? null : values.properties.lensOu,
                    sphere: values.properties.sphere === '' ? null : parseFloat(values.properties.sphere),
                    cyl: values.properties.cyl === '' ? null : parseFloat(values.properties.cyl),
                    axis: values.properties.axis === '' ? null : parseFloat(values.properties.axis),
                    addPower: values.properties.addPower === '' ? null : parseFloat(values.properties.addPower),
                    bc: values.properties.bc === '' ? null : parseFloat(values.properties.bc),
                    size: values.properties.size === '' ? null : parseFloat(values.properties.size),
                    ed: values.properties.ed === '' ? null : parseFloat(values.properties.ed),
                    segHt: values.properties.segHt === '' ? null : parseFloat(values.properties.segHt),
                },
            };
            let response
            if (isCopy) {
                formattedValues.id = null; // Ensure id is null for copy
                formattedValues.properties.id = null; // Ensure properties id is null for copy
                response = await ValidDataService.addInventory(formattedValues);
            } else {
                formattedValues.id = recordToEdit.id; // Use the existing id for update
                response = await ValidDataService.updateInventory(formattedValues)
            }
            const { code, data, message } = response

            formik.setSubmitting(false)

            if (code === 0) {
                toast.success(message);
                onClose()
                if (isCopy) {
                    onRecordCopied(data);
                } else 
                    onRecordUpdated(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.error(error);
            }
            formik.setSubmitting(false)
            toast.error('Failed to add record');
        }
    };

    const handleSupplierSelect = (supplier) => {
        setFieldValue('supplierId', supplier.id);
        setFieldValue('supplierName', supplier.supplierName);
        // reset the brand
        setFieldValue('brand', '')
    };

    const handleBrandSelect = (brand) => {
        //setFieldValue('supplierId', supplier.id);
        setFieldValue('brand', brand.name);
        setFieldValue('brandId', brand.id)
    };

    return (
        <Dialog open={open} maxWidth={'lg'} fullWidth>
            <AppDialogTitle title={`${isCopy ? 'Copy' : 'Edit'} Lens`}  onClose={onClose} />

            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Section 1: Basic Information */}
                        <ValidFrameBasicInfo formik={formik} setBrandDialogOpen={setBrandDialogOpen} setSupplierDialogOpen={setSupplierDialogOpen} labels={labels} />

                        {/* <Grid container spacing={2} mt={2}> */}
                        <Grid item xs={12} sm={4}>
                            <ValidFrameCostAndPricingForm formik={formik} />
                        </Grid>

                        <Grid item xs={12} sm={8}>
                            <ValidLensPropertiesForm formik={formik} />
                        </Grid>

                        {/* </Grid> */}


                        {/* Section 5: Inventory and Status */}
                        {/* <Grid item xs={12}>
                            <SectionTitle title="Inventory and Status" />
                        </Grid>
                        <Grid item xs={12} sm={3} mt={1}>
                            <SimpleDatePicker
                                label={"Last Ordered"}
                                onChange={(value) => setFieldValue('lastOrdered', value)}
                                value={values.lastOrdered}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} mt={1}>
                            <SimpleDatePicker
                                label={"Last Received"}
                                onChange={(value) => setFieldValue('lastReceived', value)}
                                value={values.lastReceived}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} mt={1}>
                            <SimpleDatePicker
                                label={"Last Sold"}
                                onChange={(value) => setFieldValue('lastSold', value)}
                                value={values.lastSold}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} mt={1}>
                            <TextField
                                value={values.totalSold}
                                onChange={handleChange}
                                name="totalSold"
                                label="Total Sold"
                                type="number"
                                size='small'
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} mt={1}>
                            <TextField
                                value={values.returned}
                                onChange={handleChange}
                                name="returned"
                                label="Returned"
                                type="number"
                                size='small'
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} mt={1}>
                            <TextField
                                value={values.quantityOnOrder}
                                onChange={handleChange}
                                name="quantityOnOrder"
                                label="Quantity On Order"
                                type="number"
                                size='small'
                                fullWidth
                                error={touched.quantityOnOrder && Boolean(formik.errors.quantityOnOrder)}
                                helperText={touched.quantityOnOrder && formik.errors.quantityOnOrder}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} mt={1}>
                            <TextField
                                value={values.quantityOnHand}
                                onChange={handleChange}
                                name="quantityOnHand"
                                label="Quantity On Hand"
                                type="number"
                                size='small'
                                fullWidth
                                error={touched.quantityOnHand && Boolean(formik.errors.quantityOnHand)}
                                helperText={touched.quantityOnHand && formik.errors.quantityOnHand}
                            />
                        </Grid> */}

                        <Grid item xs={12} mt={1}>
                            <TextField
                                value={values.notes}
                                onChange={handleChange}
                                name="notes"
                                label="Notes"
                                multiline
                                rows={4}
                                fullWidth
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <Typography variant='caption'>Logo (JPEG/PNG files under {formatFileSize(MAX_FILE_SIZE)}). Max files allowed {MAX_NO_OF_FILES}</Typography>
                            <AttachmentUploader
                                values={formik.values.photos}
                                onUpload={(files) => {
                                    formik.setFieldValue('photos', files);
                                    formik.setFieldTouched('photos', true);
                                }}
                                accept={
                                    ACCEPTED_IMAGE_FILE_FORMAT.reduce((acc, mimeType) => {
                                        acc[mimeType] = [];
                                        return acc;
                                    }, {})
                                }
                                maxFiles={MAX_NO_OF_FILES}
                                maxSize={MAX_FILE_SIZE}
                                attachments={attachments} // Pass the attachments
                            />
                        </Grid> */}
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={formik.isSubmitting}
                            >
                                { isCopy ? 'Create' : 'Update' }
                            </Button>
                        </Grid>
                    </Grid>
                </form>

                <SupplierListDialog
                    open={supplierDialogOpen}
                    onClose={() => setSupplierDialogOpen(false)}
                    onSelect={handleSupplierSelect} // Pass setFieldValue
                    supplierType={validLookup.supplierType.lenses}
                />
                <BrandListDialog
                    open={brandDialogOpen}
                    onClose={() => setBrandDialogOpen(false)}
                    onSelect={handleBrandSelect}
                    supplierId={values.supplierId}
                    type='lens'
                    initialFilter={values.brand}
                />
            </DialogContent>
        </Dialog>
    );
};